// 路由 /formation/profile — 直接渲染主 FormationPage, 默认 2D 剖面模式
import React from 'react';
import FormationPage from '../FormationPage';
export default function FormationProfilePage() {
  return <FormationPage initialView3D={false} />;
}
